// export interface CustomerNumberStyles {

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { MyAccountPageContext } from "@insite/content-library/Pages/MyAccountPage";
import { AddressesPageContext } from "@insite/content-library/Pages/AddressesPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { connect } from "react-redux";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";

// }
export interface AHRIIFrameStyles {
    headerProps?: TypographyProps;
    textProps?: TypographyProps;
    wrapper?: InjectableCss;
}

export const ahriIframeStyles: AHRIIFrameStyles = {
    wrapper: { css: css`iframe {
		display: block; border: none; height: 100vh; width: 100%; margin: 0; padding: 0;
	}` },
};

const styles = ahriIframeStyles;

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    
    return {
        ahriUrlFromPDP: session.properties["ahriUrlFromPDP"],
        ahriUrlOnIframePage: session.properties["ahriUrlOnIframePage"],
        customerNumber: getBillToState(state, session.billToId).value?.customerNumber,
		userName: session.userName,
    };
};

const getSsoValueFromQueryString = () => {
    if (typeof window !== "undefined") {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("ssoValue")) {
            const ssoValue = urlParams.get("ssoValue")!;
            return ssoValue;
        }
    }
    return undefined;
};

type Props = ReturnType<typeof mapStateToProps>;

const AHRIIframe: React.FC<Props> = ({ ahriUrlFromPDP: ahriUrlFromPDP, ahriUrlOnIframePage: ahriUrlOnIframePage }) => {
    const ssoValue = getSsoValueFromQueryString();
    if (ssoValue) {
        //We came from PDP	  
		var src = ahriUrlFromPDP+ssoValue;
        return (			
            <StyledWrapper {...styles.wrapper}>
                <iframe name="ahriIframe" src={src}></iframe>
            </StyledWrapper>
        );
    }
    else if (ahriUrlOnIframePage) {
        var src = ahriUrlOnIframePage;
        return (			
            <StyledWrapper {...styles.wrapper}>
                <iframe name="ahriIframe" src={src}></iframe>
            </StyledWrapper>
        );
    }
    else {
        return <></>;
    }
};


const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AHRIIframe),
    definition: {
        group: "Common",
        displayName: "AHRI Iframe Widget",
    },
};

export default widgetModule;

